// import indigo from '@material-ui/core/colors/indigo';
// import pink from '@material-ui/core/colors/pink';

// jfd: THIS FILE OVERRIDES THE MATERIAL UI DEFAULTS

export default {
  root: {
    fontFamily: "'embury-text', sans-serif",
  },
  palette: {
    primary: {
      light: '#69A5FF',
      main: '#28368B',
      dark: '#9A9BAB', //placeholder 14sep
      contrastText: '#fff'
    },
    secondary: {
      light: '#949E20',
      main: '#949E20',
      dark: '#949E20', //placeholder
      contrastText: '#fff'
    },
    neutral: {
      main: '#64748B',
      contrastText: '#fff',
    },
  },
  status: {
    danger: '#F6101F',
  },
  typography: {
    fontFamily: "'warnock-pro', sans-serif",
    // fontFamily: "'embury-text', sans-serif",
    button: {
      fontWeight: 400,
      textAlign: 'capitalize'
    },
    body1: {
      fontFamily: "'warnock-pro', sans-serif",
      // fontWeight: 400,
      // fontSize: 16,
      // color: "red"
    },
    root: {
      fontFamily: "'embury-text', sans-serif",
    }
  },
};
